var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconStudy18 = function SvgAIconStudy18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2H14.8333C15.4777 2 16 2.55103 16 3.23077V15.7692C16 16.5897 15.4829 17 14.8333 17H7.83333H3.16667C2.52233 17 2 16.449 2 15.7692V3.23077C2 2.55103 2.52233 2 3.16667 2H5.5",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.75C6 1.33579 6.33579 1 6.75 1H11.25C11.6642 1 12 1.33579 12 1.75V3.25C12 3.66421 11.6642 4 11.25 4H9H6.75C6.33579 4 6 3.66421 6 3.25V1.75Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25H12",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.25H10",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconStudy18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMi41IDJIMTQuODMzM0MxNS40Nzc3IDIgMTYgMi41NTEwMyAxNiAzLjIzMDc3VjE1Ljc2OTJDMTYgMTYuNTg5NyAxNS40ODI5IDE3IDE0LjgzMzMgMTdINy44MzMzM0gzLjE2NjY3QzIuNTIyMzMgMTcgMiAxNi40NDkgMiAxNS43NjkyVjMuMjMwNzdDMiAyLjU1MTAzIDIuNTIyMzMgMiAzLjE2NjY3IDJINS41IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNiAxLjc1QzYgMS4zMzU3OSA2LjMzNTc5IDEgNi43NSAxSDExLjI1QzExLjY2NDIgMSAxMiAxLjMzNTc5IDEyIDEuNzVWMy4yNUMxMiAzLjY2NDIxIDExLjY2NDIgNCAxMS4yNSA0SDlINi43NUM2LjMzNTc5IDQgNiAzLjY2NDIxIDYgMy4yNVYxLjc1WiIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNiA4LjI1SDEyIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02IDEyLjI1SDEwIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";